import UserService from '../../../services/UserService';

export default {
    namespaced: true,
    state: () => ({
        userDetail: '',
    }),
    getters: {
        getUserDetail: state => state.userDetail
    },
    mutations: {
        setUserDetail: (state, data) => {
            state.userDetail = data
        }
    },
    actions: {
       getUserDetail: ({commit}, userId) => {
            return new Promise((resolve, reject) => {
                UserService.userDetail(userId).then(res => {
                    commit('setUserDetail', res.data)
                    resolve(res)
                }).catch((err) => {
                    reject(err)
                })
            })
       }
    }
}